import { DeviceAccessKey } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/device_access_key_pb';
import { User } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/user_pb';
import { formatTimestamp } from '~/shared/utils/formatTimestamp';

export class DeviceAccessKeyModel {
  name: string;

  user?: User;

  accessKey: string;

  expirationTime?: string;

  claimExpirationTime?: string;

  constructor(accessKey: DeviceAccessKey) {
    this.name = accessKey.name;
    this.user = accessKey.user;
    this.accessKey = accessKey.accessKey;
    this.expirationTime = formatTimestamp(accessKey.expirationTime);
    this.claimExpirationTime = formatTimestamp(accessKey.claimExpirationTime);
  }
}
